
import { Component, Prop, Vue } from "vue-property-decorator";
import store from "@/store/index";
import Controller from "@/core/controller/Controller";
@Component
export default class ModeZone extends Vue {
  get currentMode() {
    return store.state.module1.currentMode;
  }

  get controllImg(): string {
    if (store.state.module1.currentState === "PLAYING") {
      return "img/mode/pause.png";
    } else {
      return "img/mode/continue.png";
    }
  }

  private changeState() {
    if (store.state.module1.currentState === "PLAYING") {
      store.commit.changeState("PAUSE");
      Controller.getInstance().pause();
    } else {
      store.commit.changeState("PLAYING");
      Controller.getInstance().continue();
    }
  }

  private changeToLayoutMode() {
    if (this.currentMode === "LAYOUT") return;
    store.commit.changeMode("LAYOUT");
    store.commit.changeState("PAUSE");
    Controller.getInstance().stopPlaying();
  }

  private changeToPlayMode() {
    if (this.currentMode === "PLAY") return;
    store.commit.changeMode("PLAY");
    store.commit.changeState("PLAYING");
    Controller.getInstance().startPlaying();
  }
}
